<template>
  <div
    class="sidebar--3 font-degular h-full"
    ref="sidebar"
    :class="[
      isOpen || isHovered ? '' : 'closeNav',
      isOpen ? 'static' : 'absolute',
      isOpen ? 'negativeMargin' : ''
    ]"
  >
    <nav
      class="sidebarNav--2 sidebar--2 h-full custom-scrollbar"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
    >
      <section class="section--1 h-full flex flex-col">
        <div class="sidebar-section--3 h-4 no-hover" />

        <div
          @click="
            isManager &&
              stores.length > 1 &&
              $modal.show('modal--select-store', {
                list: stores.slice().sort((a, b) => {
                  const nameA = settingsStoreIds[a] ? settingsStoreIds[a].name : a
                  const nameB = settingsStoreIds[b] ? settingsStoreIds[b].name : b
                  return nameA.toLowerCase().localeCompare(nameB.toLowerCase())
                }),
                display: (e) =>
                  e && settingsStoreIds[e] && settingsStoreIds[e].name ? settingsStoreIds[e].name : '',
                currentStore: storeName
              })
          "
          class="item--1 sidebar-section--3"
          :class="
            isManager && stores.length > 1 ? 'cursor-pointer' : 'no-hover'
          "
        >
          <unicon name="store" fill="#f2f2f0" class="icon--1 w-6 h-6" />
          <span v-if="isOpen || isHovered" class="pt-px icon--label">{{
            storeName && settingsStoreIds[storeName] && settingsStoreIds[storeName].name
              ? settingsStoreIds[storeName].name
              : ''
          }}</span>
        </div>

        <div class="sidebar-section--3 h-4 no-hover" />

        <side-nav-item
          left-icon="dashboard"
          to="/dashboard"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="pt-px icon--label"
            >Dashboard</span
          >
        </side-nav-item>
        <side-nav-item
          left-icon="files-landscapes"
          v-if="isStaff"
          to="/resources"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="pt-px icon--label"
            >Resources</span
          >
        </side-nav-item>

        <div class="sidebar-section--3 h-4 no-hover" />

        <side-nav-item
          v-if="isDeveloper"
          left-icon="eye"
          to="/insights"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="icon--label">Insights </span>
          <badge
            v-if="
              currentInvoicesRemainingCount &&
              currentInvoicesRemainingCount > 100
            "
            class="right-0"
          >
            {{ currentInvoicesRemainingCount }}
          </badge>
        </side-nav-item>

        <router-link
          class="item--1 sidebar-section--3"
          :to="currentShiftTasksPath"
          :class="isOnTasksRoute ? 'router-link-exact-active' : ''"
          @click.native="$emit('toggleDrawer')"
        >
          <unicon name="check-square" fill="#f2f2f0" class="icon--1 w-6 h-6" />
          <span v-if="isOpen || isHovered" class="pt-px icon--label">Tasks</span>
          <badge v-if="tasksUrgentRemainingCount > 0" class="right-0 font-display">
            {{ tasksUrgentRemainingCount }}
          </badge>
        </router-link>

        <side-nav-item
          left-icon="redo"
          :to="isTodayInventoryDay ? '/inventory' : '/ordering'"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="icon--label">
            {{ isTodayInventoryDay ? 'Inventory' : 'Daily Count' }}
          </span>
          <badge
            v-if="isTodayInventoryDay && isCurrentInventoryOpen && inventoryItemsRemaining && inventoryItemsRemaining.length > 0"
            class="right-0 font-display"
          >
            {{ inventoryItemsRemaining.length }}
          </badge>
          <badge
            v-else-if="!isTodayInventoryDay && orderItemsRemaining && orderItemsRemaining.length > 0"
            class="right-0 font-display"
          >
            {{ orderItemsRemaining.length }}
          </badge>
        </side-nav-item>


        <side-nav-item
          left-icon="bill"
          to="/invoicing/receive"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="icon--label">Receiving </span>
          <badge
            v-if="
              currentInvoicesRemainingCount && currentInvoicesRemainingCount > 0
            "
            class="right-0"
          >
            {{ currentInvoicesRemainingCount }}
          </badge>
        </side-nav-item>

        <side-nav-item
          v-if="isStaff"
          left-icon="exchange"
          to="/transfers"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="icon--label">Transfers </span>
          <badge v-if="getPendingTransfersCount > 0" class="right-0">
            {{ getPendingTransfersCount }}
          </badge>
        </side-nav-item>

        <side-nav-item
          v-if="isStaff"
          left-icon="trash-alt"
          to="/waste"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="pt-px icon--label">
            Waste
          </span>
          <badge v-if="getPendingWasteCount > 0" class="right-0 font-display">
            {{ getPendingWasteCount }}
          </badge>
        </side-nav-item>

        <div class="flex flex-grow w-auto"></div>

        <side-nav-item
          left-icon="cloud-database-tree"
          v-if="isManager"
          to="/reports"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="pt-px icon--label"
            >Reports</span
          >
        </side-nav-item>
        <side-nav-item
          left-icon="clipboard-notes"
          v-if="isDeveloper"
          to="/task-audit"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="pt-px icon--label"
            >Task Audit</span
          >
        </side-nav-item>
        <side-nav-item
          left-icon="cog"
          v-if="isStaff"
          to="/settings"
          @click.native="$emit('toggleDrawer')"
        >
          <span v-if="isOpen || isHovered" class="pt-px icon--label"
            >Settings</span
          >
        </side-nav-item>
        <role-switcher
          :is-open="isOpen"
          :is-hovered="isHovered"
          @role-changed="handleRoleChange"
        />
        <div @click="logOut" class="item--1 sidebar-section--3 cursor-pointer">
          <unicon name="lock" fill="#f2f2f0" class="icon--1 w-6 h-6" />
          <span v-if="isOpen || isHovered" class="pt-px icon--label"
            >Logout</span
          >
        </div>

        <!-- <div class="sidebar-section--3 h-4 no-hover" />
        <div
          @click="toggleNav"
          class="item--1 sidebar-section--3"
        >
          <unicon
            name="arrow-from-right"
            fill="#f2f2f0"
            height="24"
            width="24"
            class="icon--1"
            :class="[isOpen ? 'svg-flipped' : 'svg']"
          />
          <span
            v-if="isOpen || isHovered"
            class="pt-px icon--label"
          >{{ isOpen ? 'Collapse' : isHovered ? 'Keep Open' : '' }}</span>
        </div> -->
        <div class="sidebar-section--3 h-4 no-hover" />
      </section>
    </nav>
  </div>
</template>

<script>
import SideNavItem from '@/components/SideNav--Item'
import Badge from '@/components/Badge'
import RoleSwitcher from '@/components/RoleSwitcher'
import { mapGetters } from 'vuex'

export default {
  name: 'SideNav',
  data() {
    return {
      isOpen: true,
      isHovered: false
    }
  },
  components: {
    Badge,
    SideNavItem,
    RoleSwitcher
  },
  methods: {
    toggleDrawer() {
      this.$emit('toggleDrawer')
    },
    toggleNav() {
      this.isOpen = !this.isOpen
      this.isHovered = false
    },
    logOut() {
      this.$modal.show('modal--logout')
    },
    getName(id) {
      return id && this.settingsStoreIds[id] && this.settingsStoreIds[id].name ? this.settingsStoreIds[id].name : ''
    },
    handleRoleChange(newRole) {
      console.log('Role changed to:', newRole)
    }
  },
  computed: {
    ...mapGetters('global', ['settingsStoreIds']),
    ...mapGetters('user', [
      'isStaff',
      'isManager',
      'isAdmin',
      'isDeveloper',
      'stores',
      'storeName'
    ]),
    ...mapGetters('storeModule', [
      'tasksRemainingByShifts',
      'isCurrentInventoryOpen',
      'inventoryItemsRemaining',
      'shifts',
      'currentInvoicesRemainingCount',
      'id',
      'currentLog'
    ]),
    ...mapGetters('storeModule/transfers', [
      'pendingTransfersCount',
      'pendingTransfersCountByStoreId'
    ]),
    ...mapGetters([
      'currentShift',
      'currentShiftName',
      'currentShiftHours',
      'orderItemsRemaining',
      'isTodayInventoryDay'
    ]),
    ...mapGetters('storeModule/waste', ['pendingWasteCountByStoreId']),
    routeName() {
      return this.$route.name
    },
    getPendingTransfersCount() {
      return this.pendingTransfersCountByStoreId(this.id)
    },
    getPendingWasteCount() {
      return this.pendingWasteCountByStoreId(this.id)
    },
    isOnTasksRoute() {
      return this.$route.path.startsWith('/tasks')
    },
    currentShiftTasksPath() {
      if (this.shifts && this.shifts.length > 0) {
        return `/tasks/${this.shifts[this.currentShift || 0]}`
      }
      return '/tasks'
    },
    tasksUrgentRemainingCount() {
      if (!this.tasksRemainingByShifts) return 0
      let total = 0
      for (let i = 0; i <= this.currentShift; i++) {
        if (this.tasksRemainingByShifts[i]) {
          total += this.tasksRemainingByShifts[i].length
        }
      }
      return total
    }
  }
}
</script>

<style lang="scss" scoped>
// .openNav {
//   width: 240px;
//   will-change: width;
//   transition: width 0.2s ease-out;
// }
// .closeNav {
//   width: 72px;
//   will-change: width;
//   transition: width 0.2s ease-out;
//   // &:hover {
//   //   will-change: width;
//   //   width: 240px;
//   //   transition: width 0.2s ease-out;
//   // }
// }
.static {
  position: static;
}
.absolute {
  position: absolute;
}
.negativeMargin {
  margin-right: -72px;
}
.item--1:not(.router-link-exact-active):not(.no-hover):hover {
  background-color: rgb(31, 41, 55); /* equivalent to Tailwind's bg-gray-800 */
}


// Add custom scrollbar styles
.custom-scrollbar {
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  /* Handle on hover */
  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 3px;
    transition: background-color 0.3s ease;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &:hover {
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  }

  /* Ensure scrollbar doesn't take up space */
  overflow-y: overlay;

  /* Fallback for browsers that don't support overlay */
  @supports not (overflow-y: overlay) {
    overflow-y: auto;
    margin-right: -6px; /* Compensate for scrollbar width */
    padding-right: 6px;
  }
}

// Ensure the scrollbar doesn't affect layout
.sidebarNav--2 {
  contain: strict;
  -ms-overflow-style: none; /* IE and Edge */
}

</style>
